import React, { useEffect, useState } from 'react'
import { apiPost } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import { useForm } from 'react-hook-form'
import ErrorMessage from '../../components/ErrorMessage'
import useToastContext from 'hooks/useToastContext'
import { validationRules } from 'utils/constants'
import { validateFile } from 'utils/reusableMethods'
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai'
import FormData from 'form-data'
import { useTranslation } from 'react-i18next'

const UserAdd = ({ setShowModal, getAllUser }) => {
  const { t } = useTranslation()
  const notification = useToastContext()
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors }
  } = useForm({ mode: 'onChange', shouldFocusError: true, defaultValues: {} })
  const [addMerchantLoading, setAddMerchantLoading] = useState(false)
  const [icon, setIcon] = useState(true)
  const [passwordIcon, setPasswordIcon] = useState(true)
  const [fileErrors, setFileErrors] = useState({
    identity_card: '',
    passport: ''
  })

  useEffect(() => {
    if (watch('identity_card')?.length > 0) {
      const identityCardMsg = validateFile(watch('identity_card')[0])
      const fileSize = (watch('identity_card')[0].size / 1048576).toFixed(2)
      if (identityCardMsg) {
        setFileErrors({
          ...fileErrors,
          identity_card: identityCardMsg
        })
      } else if (fileSize > 3) {
        setFileErrors({
          ...fileErrors,
          identity_card: t('FILE_SIZE_ERROR')
        })
      } else {
        setFileErrors({
          ...fileErrors,
          identity_card: ''
        })
      }
    }
  }, [watch('identity_card')])

  useEffect(() => {
    if (watch('passport')?.length > 0) {
      const passportMsg = validateFile(watch('passport')[0])
      const fileSize = (watch('passport')[0].size / 1048576).toFixed(2)
      if (passportMsg) {
        setFileErrors({
          ...fileErrors,
          passport: passportMsg
        })
      } else if (fileSize > 3) {
        setFileErrors({
          ...fileErrors,
          passport: t('FILE_SIZE_ERROR')
        })
      } else {
        setFileErrors({
          ...fileErrors,
          passport: ''
        })
      }
    }
  }, [watch('passport')])

  const handleSubmitForm = async data => {
    try {
      if (fileErrors.identity_card || fileErrors.passport) {
        return
      }
      setAddMerchantLoading(true)
      const formData = new FormData()
      formData.append('identity_card', data.identity_card[0])
      formData.append('passport', data.passport[0])
      formData.append('first_name', data.first_name)
      formData.append('last_name', data.last_name)
      formData.append('mobile', data.mobile)
      formData.append('country_code', data.country_code)
      formData.append('email', data.email)
      formData.append('password', data.password)
      formData.append('refCode', data.refCode)

      const res = await apiPost(apiPath.createUser, formData)
      if (res.data.success === true) {
        getAllUser()
        setShowModal(false)
        notification.success(res.data.message)
      } else {
        notification.error(res?.data?.message)
      }
    } catch (err) {
      console.log('err:', err)
    } finally {
      setAddMerchantLoading(false)
    }
  }

  const preventMax = e => {
    if (e.target.value.length > 9) {
      e.target.value = e.target.value.slice(0, 9)
    }
  }

  function changeIcon () {
    setIcon(!icon)
  }
  function changePasswordIcon () {
    setPasswordIcon(!passwordIcon)
  }

  return (
    <>
      <div className='justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
        <div className='relative w-auto my-6 mx-auto max-w-3xl'>
          <div className='border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none '>
            <div className='flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t'>
              <h3 className='text-xl font-semibold'>{t('USERS_ADD_USER')}</h3>
              <button
                className=' ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none'
                onClick={() => setShowModal(false)}
              >
                <span className=' text-[#B8BBBF]  text-4xl ' title='Close'>
                  ×
                </span>
              </button>
            </div>
            <form onSubmit={handleSubmit(handleSubmitForm)} method='post'>
              <div className='relative p-6 flex-auto'>
                <div className='grid sm:grid-cols-2'>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <div className='relative z-0   w-full group'>
                      <input
                        type='text'
                        name='first_name'
                        id='first_name'
                        autoFocus={true}
                        className='block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
                        placeholder=' '
                        maxLength={15}
                        {...register('first_name', {
                          required: 'Please enter first name.',
                          minLength: {
                            value: 2,
                            message: 'Minimum length must be 2.'
                          },
                          validate: value => {
                            return !!value.trim()
                              ? true
                              : 'White spaces not allowed.'
                          }
                        })}
                      />
                      <label
                        for='first_name'
                        className='peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
                      >
                        {t('O_FIRST_NAME')}
                        <span className='text-red-500'>*</span>
                      </label>
                      <ErrorMessage message={errors?.first_name?.message} />
                    </div>
                  </div>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <div className='relative z-0   w-full group'>
                      <input
                        type='text'
                        name='last_name'
                        id='last_name'
                        className='block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
                        placeholder=' '
                        maxLength={15}
                        {...register('last_name', {
                          required: 'Please enter last name.',
                          minLength: {
                            value: 2,
                            message: 'Minimum length must be 2.'
                          },
                          validate: value => {
                            return !!value.trim()
                              ? true
                              : 'White spaces not allowed.'
                          }
                        })}
                      />
                      <label
                        for='last_name'
                        className='peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
                      >
                        {t('O_LAST_NAME')}
                        <span className='text-red-500'>*</span>
                      </label>
                      <ErrorMessage message={errors?.last_name?.message} />
                    </div>
                  </div>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <div className='relative z-0   w-full group'>
                      <select
                        type='select'
                        name='country_code'
                        id='country_code'
                        className='block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
                        placeholder=' '
                        {...register('country_code', {
                          required: 'Please enter country code.'
                        })}
                      >
                        <option value='355'>355</option>
                      </select>
                      <label
                        for='country_code'
                        className='peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
                      >
                        {t('O_COUNTRY_CODE')}
                      </label>
                      <ErrorMessage message={errors?.countryCode?.message} />
                    </div>
                  </div>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <div className='relative z-0   w-full group'>
                      <input
                        type='number'
                        id='mobile'
                        className='block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
                        placeholder=' '
                        onInput={e => preventMax(e)}
                        onKeyDown={e => {
                          if (['-', '+', 'e'].includes(e.key)) {
                            e.preventDefault()
                          }
                        }}
                        {...register('mobile', {
                          required: 'Please enter valid mobile number.',
                          minLength: {
                            value: 9,
                            message: 'Min length should be 9 digits.'
                          },
                          maxLength: {
                            value: 9,
                            message: 'Max length should be 9 digits.'
                          },
                          pattern: {
                            value: validationRules.numbers,
                            message: 'Invalid mobile number.'
                          },
                          min: {
                            value: 0,
                            message: "Value can't be less than 0."
                          }
                        })}
                      />
                      <label
                        for='mobile'
                        className='peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
                      >
                        {t('O_MOBILE_NUMBER')}
                        <span className='text-red-500'>*</span>
                      </label>
                      <ErrorMessage message={errors?.mobile?.message} />
                    </div>
                  </div>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <div className='relative z-0   w-full group'>
                      <input
                        type='text'
                        name='email'
                        id='email'
                        maxLength={50}
                        className='block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none max-w-lg focus:ring-0  peer'
                        placeholder=' '
                        {...register('email', {
                          required: 'Please enter email.',
                          pattern: {
                            value: validationRules.email,
                            message:
                              'Invalid email address (Ex: example@domain.com).'
                          },
                          validate: value => {
                            return !!value.trim()
                              ? true
                              : 'White spaces not allowed.'
                          }
                        })}
                      />
                      <label
                        for='email'
                        className='peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
                      >
                        {t('O_EMAIL_ID')}
                        <span className='text-red-500'>*</span>
                      </label>
                      <ErrorMessage message={errors?.email?.message} />
                    </div>
                  </div>

                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <div className='relative z-0 w-full group'>
                      <input
                        type='text'
                        name='refCode'
                        id='refCode'
                        maxLength={40}
                        className='block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none max-w-lg focus:ring-0  peer'
                        placeholder=' '
                        {...register('refCode', {
                          // required: 'Please enter referral code.',
                          pattern: {
                            value: validationRules.removeWhitespace,
                            message:
                              'White space and special character not allowed.'
                          }
                        })}
                      />
                      <label
                        for='refCode'
                        className='peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
                      >
                        {t('O_REF_CODE')}
                      </label>
                      <ErrorMessage message={errors?.refCode?.message} />
                    </div>
                  </div>

                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <div className='relative z-0   w-full group'>
                      <input
                        type={icon ? 'password' : 'text'}
                        name='password'
                        autoComplete='new-password'
                        id='password'
                        maxLength={16}
                        className='block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
                        placeholder=' '
                        {...register('password', {
                          required: 'Please enter password.',
                          pattern: {
                            value: validationRules.password,
                            message:
                              'Password must contain lowercase,uppercase characters, numbers, special character and at least 8 character long.'
                          },

                          validate: value => {
                            return !!value.trim()
                              ? true
                              : 'White spaces not allowed.'
                          },
                          maxLength: {
                            value: 15,
                            message: 'Password should not exceed 15 characters.'
                          }
                        })}
                      />
                      <label
                        for='password'
                        className='peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
                      >
                        {t('O_PASSWORD')}
                        <span className='text-red-500'>*</span>
                      </label>
                      {icon ? (
                        <span
                          className='password_view absolute top-[18px] right-[20px]'
                          onClick={() => changeIcon()}
                        >
                          <AiFillEyeInvisible />
                        </span>
                      ) : (
                        <span
                          className='password_view absolute top-[18px] right-[20px]'
                          onClick={() => changeIcon()}
                        >
                          <AiFillEye />
                        </span>
                      )}
                      <ErrorMessage message={errors?.password?.message} />
                    </div>
                  </div>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <div className='relative z-0   w-full group'>
                      <input
                        type={passwordIcon ? 'password' : 'text'}
                        name='confirm_password'
                        id='confirm_password'
                        maxLength={15}
                        className='block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
                        placeholder=' '
                        {...register('confirm_password', {
                          required: 'Please enter confirm password.',
                          validate: val => {
                            if (watch('password') !== val) {
                              return 'Your password and confirm password do not match.'
                            }
                          }
                        })}
                      />
                      <label
                        for='confirm_password'
                        className='peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
                      >
                        {t('O_CONFIRM_PASSWORD')}
                        <span className='text-red-500'>*</span>
                      </label>
                      {passwordIcon ? (
                        <span
                          className='password_view absolute top-[18px] right-[20px]'
                          onClick={() => changePasswordIcon()}
                        >
                          <AiFillEyeInvisible />
                        </span>
                      ) : (
                        <span
                          className='password_view absolute top-[18px] right-[20px]'
                          onClick={() => changePasswordIcon()}
                        >
                          <AiFillEye />
                        </span>
                      )}
                      <ErrorMessage
                        message={errors?.confirm_password?.message}
                      />
                    </div>
                  </div>

                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <div className='relative z-0   w-full group'>
                      <div className='block py-3 h-14 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'>
                        <input
                          type='file'
                          name='identity_card'
                          placeholder='Identity Card '
                          className='form-control'
                          accept='image/png,image/jpeg,image/jpg'
                          {...register('identity_card', {
                            required: 'Please provide identity card.'
                          })}
                        />
                      </div>
                      <label
                        for='floating_file'
                        className='peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-1 left-0 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
                      >
                        {t('O_IDENTITY_CARD')}
                        <span className='text-red-500'>*</span>
                      </label>
                      <ErrorMessage
                        message={
                          errors?.identity_card?.message ||
                          fileErrors.identity_card
                        }
                      />
                    </div>
                  </div>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <div className='relative z-0   w-full group'>
                      <div className='block py-3 h-14 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'>
                        <input
                          type='file'
                          name='passport'
                          placeholder='passport'
                          className='form-control'
                          accept='image/jpeg, image/png, image/jpg'
                          {...register('passport', {
                            required: 'Please provide passport.'
                          })}
                        />
                      </div>
                      <label
                        for='floating_file'
                        className='peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-1 left-0 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
                      >
                        {t('O_PASSPORT')}
                        <span className='text-red-500'>*</span>
                      </label>
                      <ErrorMessage
                        message={
                          errors?.passport?.message || fileErrors.passport
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className='flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b'>
                <button
                  className='text-black bg-[#E1E1E1] font-normal   px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150'
                  type='button'
                  onClick={() => setShowModal(false)}
                >
                  {t('O_BACK')}
                </button>
                <button
                  className={` bg-[#8FC150] cursor-pointer  text-white active:bg-emerald-600 font-normal text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150`}
                  type='submit'
                >
                  {addMerchantLoading ? 'Loading...' : <>{t('O_ADD')}</>}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className='opacity-25 fixed inset-0 z-40 bg-black' />
    </>
  )
}

export default UserAdd
